import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { signoutSuccess } from "../redux/user/userSlice";
import { useDispatch, useSelector } from 'react-redux';
import config from "../config";
const SubAdmin = ({ children }) => {
    let [sidebarActive, seSidebarActive] = useState(false);
    let [mobileMenu, setMobileMenu] = useState(false);
    let [ActiveLink,setActiveLink] = useState()
    const location = useLocation(); // Hook to get the current route
    const user_data = useSelector((state)=> state.user.currentUser)
    const user_role = useSelector((state)=> state.roles)
    const individual = useSelector((state)=>  state.Individual.individual_role)
    console.log(individual,"=============individual=================>>>>>")





  
    const handleLinkClick = (link) => {
      setActiveLink(link);
    }
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const logout = async(e)=>{
        e.preventDefault();//j
        const data = await fetch(`${config.apiUrlBetaV2}signout`,{
          method: "POST",
          headers: { 'Content-Type': 'application/json' }
    
        })
    
    
  
        const jsonData = await data.json()
        if(jsonData.success == true){
          localStorage.removeItem("access_token")
          dispatch(signoutSuccess())
          navigate("/")
    
        }
      }
    useEffect(() => {
      // Function to handle dropdown clicks
      const handleDropdownClick = (event) => {
        event.preventDefault();
        const clickedLink = event.currentTarget;
        const clickedDropdown = clickedLink.closest('.dropdown');
  
        if (!clickedDropdown) return;
  
        const isActive = clickedDropdown.classList.contains('open');
  
        // Close all dropdowns
        const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
        allDropdowns.forEach((dropdown) => {
          dropdown.classList.remove('open');
        });
  
        // Toggle the clicked dropdown
        if (!isActive) {
          clickedDropdown.classList.add('open');
        }
      };
  
      // Attach click event listeners to all dropdown triggers
      const dropdownTriggers = document.querySelectorAll('.sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link');
  
      dropdownTriggers.forEach((trigger) => {
        trigger.addEventListener('click', handleDropdownClick);
      });
  
      // Function to open submenu based on current route
      const openActiveDropdown = () => {
        const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
        allDropdowns.forEach((dropdown) => {
          const submenuLinks = dropdown.querySelectorAll('.sidebar-submenu li a');
          submenuLinks.forEach((link) => {
            if (link.getAttribute('href') === location.pathname || link.getAttribute('to') === location.pathname) {
              dropdown.classList.add('open');
            }
          });
        });
      };
  
      // Open the submenu that contains the open route
      openActiveDropdown();
  
  
  
      // Cleanup event listeners on unmount
      return () => {
        dropdownTriggers.forEach((trigger) => {
          trigger.removeEventListener('click', handleDropdownClick);
        });
  
      };
    }, [location.pathname]);
  
  
    let sidebarControl = () => {
      seSidebarActive(!sidebarActive);
    };
  
    let mobileMenuControl = () => {
      setMobileMenu(!mobileMenu);
    };
  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
    {/* sidebar */}
    <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
      <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
        <Icon icon="radix-icons:cross-2" />
      </button>
      <div>
        <Link to="/" className="sidebar-logo">
   
          <img
            src="assets/images/stpng.png"
            alt="site logo"
            className="light-logo"
          />

          <img
            src="assets/images/stpng.png"
            alt="site logo"
            className="dark-logo"
          />
          <img
            src="assets/images/stpng.png"
            alt="site logo"
            className="logo-icon"
          />
        </Link>
      </div>
      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">


          <li className="sidebar-menu-group-title">Manage Loans</li>
          <li>
          {individual?.loan_details?.restrict == true &&(

            <NavLink to="/Manager_loan_details" className={(navData) =>
              navData.isActive ? "active-page" : ""
            }>
            
              <Icon icon="mage:email" className="menu-icon" />
              <span>Loan Details</span>
            </NavLink>
          )}
          </li>
          <li>

            <NavLink to="/Manger_mapping" className={(navData) =>
              navData.isActive ? "active-page" : ""
            }>
              <Icon icon="bi:chat-dots" className="menu-icon" />
              <span>Loan Mapping</span>
            </NavLink>
          </li>

          <li className="sidebar-menu-group-title">Manage User</li>

          {/* Users Dropdown */}
          <li className="dropdown">
            <Link to="#">
              <Icon icon="flowbite:users-group-outline" className="menu-icon" />
              <span>Team</span>
            </Link>
            <ul className="sidebar-submenu">
              <li>

                <NavLink to="/Manager-Team-list" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <i className="ri-circle-fill circle-icon text-primary-600 w-auto" /> Team List
                </NavLink>
              </li>
        
              <li>

                <NavLink to="/add-Team" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <i className="ri-circle-fill circle-icon text-info-main w-auto" /> Add Team
                </NavLink>
              </li>
              <li>
                         <li>
                           <NavLink to={`/manager-profile?${user_data?._id}`} className={(navData) =>
                             navData.isActive ? "active-page" : ""
                           }>
                             <i className="ri-circle-fill circle-icon text-danger-main w-auto" /> View Profile
                           </NavLink>
                         </li>

              </li>
            </ul>
          </li>

        </ul>
      </div>
    </aside>

    <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
      <div className="navbar-header">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center gap-4">
              <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                {
                  sidebarActive ? (<Icon
                    icon="iconoir:arrow-right"
                    className="icon text-2xl non-active"
                  />) : (<Icon
                    icon="heroicons:bars-3-solid"
                    className="icon text-2xl non-active "
                  />)
                }
              </button>
              <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                <Icon
                  icon="heroicons:bars-3-solid"
                  className="icon"
                />
              </button>
              {/* <form className="navbar-search">
                <input type="text" name="search" placeholder="Search" />
                <Icon icon="ion:search-outline" className="icon" />
              </form> */}
            </div>
          </div>
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center gap-3">
              {/* ThemeToggleButton */}
              <ThemeToggleButton />
      
   
              <div className="dropdown">
                <button
                  className="d-flex justify-content-center align-items-center rounded-circle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <img
                    src={user_data?.profilePicture}
                    alt="image_user"
                    className="w-40-px h-40-px object-fit-cover rounded-circle"
                  />
                </button>
                <div className="dropdown-menu to-top dropdown-menu-sm">
                  <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <h6 className="text-lg text-primary-light fw-semibold mb-2">
                       {user_data?.username}
                      </h6>
                      <span className="text-secondary-light fw-medium text-sm">{user_data?.role}</span>
                    </div>
                    <button type="button" className="hover-text-danger">
                      <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                    </button>
                  </div>
                  <ul className="to-top-list">
                    <li>
                    
                                    <NavLink to={`/agent-profile?${user_data?._id}`} className={(navData) =>
                                      navData.isActive ? "active-page" : ""
                                    }>
                                      <i className="ri-circle-fill circle-icon text-danger-main w-auto" /> View Profile
                                    </NavLink>
                    </li>

                    <li>
                    <Link className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
to="#"
onClick={(e) => {
  handleLinkClick('LOGOUT');
  logout(e);
}}
>

                        <Icon icon="lucide:power" className="icon text-xl"  /> Log Out
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Profile dropdown end */}

            </div>
          </div>
        </div>
      </div>

      {/* dashboard-main-body */}
      <div className="dashboard-main-body">{children}</div>

      {/* Footer section */}
      <footer className="d-footer">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <p className="mb-0">© 2024 Stucred. All Rights Reserved.</p>
          </div>
          <div className="col-auto">
            <p className="mb-0">
              Made by <span className="text-primary-600">Stucred</span>
            </p>
          </div>
        </div>
      </footer>
    </main>
  </section>
  )
}

export default SubAdmin